module.exports = __webpack_public_path__ + "static/img/division2.87b7d51f.png";